export function dateKey(value: unknown): string {
  return `${value ?? ''}`.trim().split('T')[0];
}

export function formatInputDate(value: unknown): string {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const raw = `${value ?? ''}`.trim();
  if (!raw) {
    return '';
  }

  const isoDate = raw.split('T')[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) {
    return isoDate;
  }

  const localDate = raw.match(/^(\d{1,2})[-./](\d{1,2})[-./](\d{4})$/);
  if (localDate) {
    const [, day, month, year] = localDate;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const parsed = Date.parse(raw);
  return Number.isFinite(parsed) ? new Date(parsed).toISOString().slice(0, 10) : '';
}

export function formatDisplayDate(value: unknown): string {
  const raw = dateKey(value);
  const [year, month, day] = raw.split('-');
  return year && month && day ? `${day}-${month}-${year}` : raw;
}

export function formatDisplayTime(timeValue: unknown): string {
  const [hours = '00', minutes = '00'] = `${timeValue ?? ''}`.trim().split(':');
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
}

export function formatDisplayDateTime(dateValue: unknown, timeValue: unknown): string {
  return `${formatDisplayDate(dateValue)} ${formatDisplayTime(timeValue)}`.trim();
}
